import clsx from '~/utils/clsx';
import { Hotkey as HotkeyCN } from './hotkey.css';

export default function Hotkey(p) {
  return <span class={clsx("Hotkey", HotkeyCN, p.cn)}>{p.hotkey}</span>;
}
